import React from 'react';
import { LayoutDashboard, Sparkles, Package, Truck, LineChart, Zap, Crown, Clock } from 'lucide-react';
import { useAuth } from '../context/AuthContext';

const NAV = [
  { key: 'dashboard', label: 'Dashboard', icon: LayoutDashboard },
  { key: 'optimize', label: 'Optimize Shipment', icon: Sparkles },
  { key: 'shipments', label: 'Shipments', icon: Package },
  { key: 'carriers', label: 'Carriers', icon: Truck },
  { key: 'analytics', label: 'Savings & Analytics', icon: LineChart },
];

export default function Sidebar({ current, onChange }) {
  const { user } = useAuth();
  const trial = user?.trial || {};
  const inTrial = trial.in_trial;
  const expired = trial.expired;
  const isPaid = !!user?.is_pro;

  return (
    <aside
      className="hidden md:flex md:flex-col w-[245px] shrink-0 text-white px-4 py-6"
      style={{ background: 'var(--lf-navy)' }}
    >
      <div className="text-xl font-extrabold mx-2 mb-7">
        Lindore <span style={{ color: '#60a5fa' }}>FreightAI</span>
      </div>
      <nav className="space-y-1 flex-1">
        {NAV.map((item) => {
          const Icon = item.icon;
          const active = current === item.key;
          return (
            <button
              key={item.key}
              onClick={() => onChange(item.key)}
              className="lf-sidebar-btn w-full flex items-center gap-3 text-left px-3 py-3 rounded-lg text-sm font-medium"
              style={{
                background: active ? 'var(--lf-navy-hover)' : 'transparent',
                color: active ? '#ffffff' : '#cbd5e1',
                border: 'none',
                cursor: 'pointer',
              }}
              onMouseEnter={(e) => {
                if (!active) {
                  e.currentTarget.style.background = 'var(--lf-navy-hover)';
                  e.currentTarget.style.color = '#ffffff';
                }
              }}
              onMouseLeave={(e) => {
                if (!active) {
                  e.currentTarget.style.background = 'transparent';
                  e.currentTarget.style.color = '#cbd5e1';
                }
              }}
            >
              <Icon size={17} />
              {item.label}
            </button>
          );
        })}
      </nav>

      {user && !isPaid && (
        <div
          className="mt-4 rounded-xl p-3 text-center"
          style={{
            background: expired
              ? 'linear-gradient(135deg,#7c2d12 0%, #9a3412 100%)'
              : 'linear-gradient(135deg,#172554 0%, #1e3a8a 100%)',
            border: expired ? '1px solid #c2410c' : '1px solid #1e40af',
          }}
        >
          <div
            className="w-9 h-9 rounded-lg mx-auto mb-2 flex items-center justify-center"
            style={{ background: 'linear-gradient(135deg,#f59e0b,#f97316)' }}
          >
            {inTrial ? <Clock size={16} color="#fff" /> : <Crown size={16} color="#fff" />}
          </div>
          <div className="text-sm font-bold mb-1" style={{ color: '#ffffff' }}>
            {inTrial
              ? trial.days_remaining <= 1
                ? 'Last day of trial'
                : `${trial.days_remaining} days left`
              : expired
              ? 'Trial ended'
              : 'Lindore Pro'}
          </div>
          <div className="text-[11px] mb-3" style={{ color: '#cbd5e1' }}>
            {inTrial
              ? 'Keep GPT-5 chat, load board & PDFs'
              : expired
              ? 'Resubscribe for $49/mo'
              : 'GPT-5 explanations, chat, load board, PDFs'}
          </div>
          <button
            onClick={() => onChange('upgrade')}
            className="w-full inline-flex items-center justify-center gap-1 text-xs font-bold py-2 rounded-lg"
            style={{
              background: '#ffffff',
              color: 'var(--lf-navy)',
              border: 'none',
              cursor: 'pointer',
            }}
          >
            <Zap size={12} /> {inTrial ? 'Upgrade $49/mo' : 'Subscribe $49/mo'}
          </button>
        </div>
      )}

      {isPaid && (
        <div
          className="mt-4 rounded-xl p-3 flex items-center gap-2"
          style={{ background: 'rgba(245,158,11,.1)', border: '1px solid rgba(245,158,11,.3)' }}
        >
          <Crown size={14} style={{ color: '#f59e0b' }} />
          <div>
            <div className="text-xs font-bold" style={{ color: '#f59e0b' }}>Pro</div>
            <div className="text-[10px]" style={{ color: '#fcd34d' }}>All features unlocked</div>
          </div>
        </div>
      )}
    </aside>
  );
}
